// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

/**
 * Field IDs tracked for SAR progress calculation. Plea fields are excluded
 * because they are optional — users fill them in post-sentencing.
 */
export const REQUIRED_FIELD_IDS = [
  "prosecutingAttorney",
  "defenseAttorney",
  "sentencingDate",
] as const;

/** All charge fields the user can edit (superset of REQUIRED_FIELD_IDS). */
export const ALL_EDITABLE_FIELD_IDS = [
  ...REQUIRED_FIELD_IDS,
  "pleaAgreement",
  "pleaDate",
] as const;

export type EditableChargeField = (typeof ALL_EDITABLE_FIELD_IDS)[number];
